<template>
    <div id="post-page" class="container">
        <div class="row">
            <div class="col-lg-8 pl-3 mt-40">
                <div class="row">
                    <div class="col-lg-12">
                        <single-post-header :data="post"></single-post-header>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <single-post-content :data="post" :banner="paragraph_190" :gbanner="gparagraph_190"></single-post-content>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="fb-like" :data-href="shareUrl" data-width="" data-layout="standard" data-action="like" data-size="small" data-share="true"></div>
                    </div>
                </div>
                <div class="row" v-if="hasPost() && post.tags && post.tags.length > 0">
                    <div class="col-lg-12 post-tags">
                        <span>Kulcsszavak: </span>
                        <tag v-for="tag in post.tags" v-bind:data="tag" v-bind:key="tag.ID"></tag>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 mt-3" v-if="(content_190 && content_190.id) || (gcontent_190 && gcontent_190.id) ">
                        <ad :data="content_190" v-if="(content_190 && content_190.id)"></ad>
                        <google-ad :data="gcontent_190" v-if="(gcontent_190 && gcontent_190.id)"></google-ad>
                    </div>
                </div>
                <div class="row" v-if="content_90 && content_90.id">
                    <div class="col-lg-12 mt-3">
                        <ad :data="content_90"></ad>
                    </div>
                </div>
                <div class="row" v-show="relatedPosts" v-if="hasPost() && relatedPosts && relatedPosts.length > 0">
                    <div class="col-lg-12 pr-md-0 pr-lg-0">
                      <div class="row">
                        <div class="col-lg-12">
                          <post-block-group title="Kapcsolódó cikkek" color="#ec0000" class="row related-posts">
                            <post-list-item v-for= "item in relatedPosts" v-bind:data="item" v-bind:key="item.ID"></post-list-item>
                          </post-block-group>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="row p-3 p-lg-0 pt-lg-3" v-if="(right_370 && right_370.id) || (gright_370 && gright_370.id)">
                    <ad :data="right_370" v-if="(right_370 && right_370.id)"></ad>
                    <google-ad :data="gright_370" v-if="(gright_370 && gright_370.id)"></google-ad>
                </div>
                <div class="row pt-3">
                    <widget v-if="recentPostCover && recentPostCover.title" class="widget row most-recent mt-40 p-0 mr-4 ml-lg-0 ml-md-3 ml-sm-3" title="Legfrissebb">
                        <div class="row pad-right-block">
                            <post-small-block class="" color="#000" :data="recentPostCover"></post-small-block>
                        </div>
                        <div class="row">
                            <div class="list-post-block ">
                                <ul class="list-post unstyled pad-right-block">
                                    <post-list-item-small v-for="item in recentPosts" v-bind:data="item" v-bind:key="item.ID">
                                    </post-list-item-small>
                                </ul>
                            </div>
                        </div>
                    </widget>
                </div>
                <div class="row pt-3 ml-3 ml-lg-0" v-if="(right_600 && right_600.id) || (gright_600 && gright_600.id)">
                    <ad :data="right_600" v-if="(right_600 && right_600.id)"></ad>
                    <google-ad :data="gright_600" v-if="(gright_600 && gright_600.id)"></google-ad>
                </div>
                <div class="row">
                    <widget class="widget row w-fan-page mt-20 p-0 mr-lg-4 ml-lg-0 ml-md-3 ml-sm-3 mr-sm-3 ml-xs-3" title="Kövessen minket">
                        <div class="fb-page pl-0"
                             data-href="https://www.facebook.com/Szekelyfold.ma/"
                             data-width="350"
                             data-hide-cover="true"
                             data-show-facepile="false"></div>
                    </widget>
                </div>
                <div class="row mt-4 mr-0 pr-0 mb-4">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pl-lg-0 ml-xs-2 ml-sm-2 pr-xs-1 pr-sm-1">
                        <div class="row" v-for="campaign in campaigns" v-bind:data="campaign" v-bind:key="campaign.ID">
                            <campaign :data="campaign" class="w-100 p-sm-3 p-xs-3 p-md-3 pl-lg-2 pr-lg-4"></campaign>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="mostPopularPostCover && mostPopularPostCover.title">
                    <widget class="widget row most-popular mt-20 p-0 mr-4 ml-lg-0 ml-md-3 ml-sm-3" title="Legnépszerűbb">
                        <div class="row pad-right-block">
                            <post-small-block class="" color="#000" :data="mostPopularPostCover"></post-small-block>
                        </div>
                        <div class="row">
                            <div class="list-post-block">
                                <ul class="list-post unstyled pad-right-block">
                                    <post-list-item-small v-for="item in mostPopularPosts" v-bind:data="item" v-bind:key="item.ID">
                                    </post-list-item-small>
                                </ul>
                            </div>
                        </div>
                    </widget>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PostBlockGroup from "../post/PostBlockGroup";
    import PostSmallBlockHorizontal from "../post/PostSmallBlockHorizontal";
    import PostListItemSmall from "../post/PostListItemSmall";
    import PostSmallBlock from "../post/PostSmallBlock";
    import PostListItem from "../post/PostListItem";
    import Campaign from "../addons/Campaigns";
    import Widget from "../addons/Widget"
    import SinglePostHeader from "../post/SinglePost/SinglePostHeader";
    import SinglePostContent from "../post/SinglePost/SinglePostContent";
    import Tag from '../addons/Tag'
    import Ad from '../addons/Ad'
    import GoogleAd from '../addons/GoogleAd'
    import { mapGetters } from 'vuex'
    import Vue from 'vue';
    import VueFacebook from 'vue-facebook';
    Vue.use(VueFacebook)
    import * as banners from '../../constants/banners'

    export default {
        name: 'PostPage',
        data() {
            return {
                post: this.getPost,
                recentPostCover: this.getRecentPostCover,
                recentPosts: this.getRecentPosts,
                mostPopularPostCover: this.getMostPopularPostCover,
                mostPopularPosts: this.getMostPopularPosts,
                relatedPosts: this.getRelatedPosts,
                campaigns: [

                ],
                contentBannerData: {},
                banners: [],
                gbanners: [],
                right_370: {},
                gright_370: {},
                right_600: {},
                gright_600: {},
                paragraph_190: {},
                gparagraph_190: {},
                content_90: {},
                content_190: {},
                gcontent_190: {}
            }
        },
        components: {
            SinglePostHeader,
            SinglePostContent,
            PostListItemSmall,
            PostSmallBlock,
            PostListItem,
            Campaign,
            Widget,
            PostBlockGroup,
            PostSmallBlockHorizontal,
            Tag,
            Ad,
            GoogleAd,
        },
        computed: {
            ...mapGetters([
                'getRecentPostCover',
                'getRecentPosts',
                'getMostPopularPostCover',
                'getMostPopularPosts',
                'getPost',
                'getRelatedPosts',
            ]),
            shareUrl() {
                return window.location.href;//this.$route.path;
            }
        },
        methods: {
            hasPost() {
                if(this.post && this.post.id !== undefined) {
                    return true;
                }

                return false;
            },
            getBannerBySide(side) {
                if(this.banners) {
                    return this.banners.find(b => b.side == side);
                }
            },
            getBanners() {
                this.$store.dispatch('getBanners', [
                    'right_370','right_600','paragraph_190','content_90','content_190'
                ]).then((response) => {
                    this.banners = response ? response : [];
                   this.right_370 = this.banners.find(b => b.side === 'right_370');
                   this.right_600 = this.banners.find(b => b.side === 'right_600');
                   this.paragraph_190 = this.banners.find(b => b.side === 'paragraph_190');
                   this.content_190 = this.banners.find(b => b.side === 'content_190');
                   this.content_90 = this.banners.find(b => b.side === 'content_90'); //optional, custom
                });

                this.$store.dispatch('getGBanners', [
                    'gright_370','gright_600','gparagraph_190', 'gcontent_190'
                ]).then((response) => {
                this.gbanners = response ? response : [];
                   this.gright_370 = this.gbanners.find(b => b.position === 'gright_370');
                   this.gright_600 = this.gbanners.find(b => b.position === 'gright_600');
                   this.gparagraph_190 = this.gbanners.find(b => b.position === 'gparagraph_190');
                   this.gcontent_190 = this.gbanners.find(b => b.position === 'gcontent_190');
                   //console.log('store load gb gright_370', this.gright_370);
                });
            },
        },
        mounted() {
            this.getBanners();
        },
        watch: {
            getPost: function (newVal) {
                this.post = newVal;
            },
            getRelatedPosts: function (newVal) {
              this.relatedPosts = newVal;
            },
            getRecentPostCover: function (newVal) {
                this.recentPostCover = newVal;
            },
            getRecentPosts: function (newVal) {
                this.recentPosts = newVal;
            },
            getMostPopularPostCover: function (newVal) {
                this.mostPopularPostCover = newVal;
            },
            getMostPopularPosts: function (newVal) {
                this.mostPopularPosts = newVal;
            },
        }
    }
</script>

<style lang="scss">
    @import '~@/absctracts/variables.scss';

    .post-tags {
        margin-top: 20px;

        span {
            background: #1c1c1c;
            color: #fff;
            font-size: 12px;
            padding: 3px 6px;
            text-transform: uppercase;
            margin-right: 5px;
        }
    }

    .related-posts {
        .post-thumb {
            img {
                width: 130% !important;
                max-width: 130% !important;
                object-fit: cover;
            }
        }
    }

    @media (max-width: 576px) {
        .widget {
            margin-left: 15px !important;
            margin-right: 15px !important;
        }

        #post-page {
            #campaign {
                padding-left: 15px;
                padding-bottom: 10px;
            }
        }
    }
</style>
